import { useEffect } from 'react';
import { merge, get, set, capitalize } from 'lodash';
import { useFormikContext } from 'formik';
import { useSelector } from 'react-redux';

import { tripLoadedReqDataSelector, tripReqDataSelector } from 'modules/common/FillTrip/selectors';
import { PhoneService } from '../../../entities/Phone/service';

const FormikFillFields = () => {
  const { setFieldValue, values, validateForm } = useFormikContext();
  const reqData = useSelector(tripReqDataSelector);
  const { loaded } = useSelector(tripLoadedReqDataSelector);

  useEffect(() => {
    if (!reqData) return;

    const { type, data } = reqData;

    if (type) {
      const mergedData = merge({}, get(values, type, {}), data);
      const phone = get(mergedData, 'phone.number');

      if (phone) {
        set(mergedData, 'phone.number', PhoneService.formatPhone(phone));
      }

      if (loaded.isFastLine) {
        const reverseFast = {
          forwarder: 'driver',
          driver: 'forwarder',
        };
        setFieldValue(`isFastLine${capitalize(type)}`, true);
        // @ts-ignore
        setFieldValue(`isFastLine${capitalize(reverseFast[type])}`, false);
      }

      setFieldValue(type, mergedData);
      validateForm();
    }
  }, [reqData]);

  return null;
};

export default FormikFillFields;
